import { render, staticRenderFns } from "./CampanhaList.vue?vue&type=template&id=1e1b0418&scoped=true"
import script from "./CampanhaList.vue?vue&type=script&lang=js"
export * from "./CampanhaList.vue?vue&type=script&lang=js"
import style0 from "./CampanhaList.vue?vue&type=style&index=0&id=1e1b0418&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1b0418",
  null
  
)

export default component.exports